<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn fab dark color="accent" v-on="on">
                <v-icon>fa-user</v-icon>
            </v-btn>
        </template>
        <v-list light min-width="160px">
            <v-list-item
                v-for="(item, index) in profileMenuList"
                :key="index"
                :ref="item.text"
                @click="submitMenu(item.execute)"
            >
                <v-icon v-if="item.icon" small class="mr-1">
                    {{ item.icon }}
                </v-icon>
                <v-list-item-content>
                    <v-list-item-title class="text-caption">
                        {{ $t(item.text) }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

interface Menu {
    icon: string;
    text: string;
    execute: (caller: any) => void;
}

@Component({
    name: 'ProfileButton',
})
export default class ProfileButton extends Vue {
    @Prop({ default: [] }) profileMenu: Array<Menu>;

    get profileMenuList(): Array<Menu> {
        return this.profileMenu;
    }

    submitMenu(execute: (caller: any) => void): void {
        this.$emit('clickMenu', execute);
    }
}
</script>
